import React from 'react';
import { Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { Box } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const App = (props) => {

  const { dates/*, objectsLength*/ } = props;

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Movimentação da secretaria (requerimentos)',
      },
    },
  };
  
  //const labels = dates;
  const labels = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho'];
  const objectsLength = [3, 4, 8, 5, 7, 2, 1];
  
  const data = {
    labels,
    datasets: [
      {
        label: 'Pendentes',
        data: labels.map(() => faker.number.int({ min: 0, max: 100 })),
        borderColor: 'rgb(251, 140, 0)',
        backgroundColor: 'rgba(255, 217, 102, 1)',
      },
      {
        label: 'Aprovados',
        data: labels.map(() => faker.number.int({ min: 0, max: 100 })),
        borderColor: 'rgb(0, 255, 39)',
        backgroundColor: 'rgba(0, 255, 39, 0.5)',
      },
      {
        label: 'Negados',
        data: labels.map(() => faker.number.int({ min: 0, max: 100 })), //objectsLength
        borderColor: 'rgb(255, 0, 39)',
        backgroundColor: 'rgba(255, 0, 39, 0.5)',
      },
    ],
  };

  return (
    <Box
      {...props}
      sx={{
        height: 530,
        width: 700,
        margin: 0,
        marginLeft: 17,
        marginTop: 0,
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: 1,
        borderWidth: 5,
        borderColor: '#323232',
      }}
    >
      <Line options={options} data={data} />
    </Box>
  );
}

export default App;